// The file policy of a counterparty's documents (TX-US-0033) is a deal's documents', stated in
// documents/dealFiles.js: PDF, JPEG, PNG, the two Office formats working papers arrive in, and a
// saved email, so senior management's answer to an override is attached as it is (TX-US-0042). It
// mirrors ALLOWED_CONTENT_TYPES in trex/counterparties/documents/service.py; the API is the
// authority.

import { validateDealFile } from '../../documents/dealFiles.js';

export { ACCEPT, FORMATS_HINT, contentTypeOf } from '../../documents/dealFiles.js';

export const validateCounterpartyFile = validateDealFile;

// What a row says under the file's name: its size, who attached it and the day they did.
export function documentMeta(document, formatBytes) {
  const attached = new Date(document.confirmed_at ?? document.created_at).toLocaleDateString();
  return `${formatBytes(document.size_bytes ?? 0)} · ${document.uploaded_by} · ${attached}`;
}

// What the files panel shows beside the list (TX-US-0034): an image inline and a PDF in the
// browser's own viewer. A Word or Excel file, and a saved email, is downloaded to be opened.
export const isImage = (document) => document.content_type.startsWith('image/');

export const previewable = (document) =>
  isImage(document) || document.content_type === 'application/pdf';

// The document the preview shows: the one picked while it is still on the list, the first
// otherwise - so a deleted selection falls back and a new list opens on its first file.
export const selectedAmong = (documents, selectedId) =>
  documents.find((document) => document.document_id === selectedId) ?? documents[0] ?? null;
